import { isAdminApp } from './utils/platform';
import AdminLoader from './AdminLoader';
import JukeboxLoader from './JukeboxLoader';
import { isLoggedUserAdminOfCurrentBox } from './utils/security';

const AppLoader = () => (isAdminApp() || isLoggedUserAdminOfCurrentBox() ? <AdminLoader /> : <JukeboxLoader />);

export default AppLoader;
